{
  "appName": "Planetra",
  "loading": "Memuatkan",
  "actions": {
    "cancel": "Batal",
    "close": "Tutup",
    "goToProjects": "Kembali ke projek",
    "reload": "Muat semula halaman",
    "retry": "Cuba lagi",
    "save": "Simpan"
  },
  "language": {
    "label": "Bahasa",
    "en": "English",
    "ms": "Bahasa Melayu"
  },
  "realtime": {
    "live": "Langsung",
    "liveHint": "Kemajuan larian dikemas kini sebaik sahaja ia berlaku.",
    "connecting": "Menyambung",
    "connectingHint": "Membuka sambungan untuk kemajuan larian secara langsung.",
    "offline": "Tidak langsung",
    "offlineHint": "Kemas kini langsung telah terhenti. Semua yang dipaparkan masih betul — ia akan dimuat semula apabila sambungan kembali."
  },
  "severity": {
    "high": "Tinggi",
    "medium": "Sederhana",
    "low": "Rendah"
  },
  "skipToContent": "Langkau ke kandungan utama",
  "nav": {
    "label": "Utama",
    "overview": "Gambaran keseluruhan",
    "projects": "Semua projek",
    "tools": "Alatan",
    "workspace": "Ruang kerja peta",
    "dashboard": "Papan pemuka",
    "account": "Akaun dan sesi"
  }
}
